const API_URL = process.env.VUE_APP_API_URL;

export const EMAIL_AUTH_URL = `${API_URL}/auth/email`;
export const OPERATIONS_URL = `${API_URL}/private/operations`;
export const PAID_INSTALLMENTS_URL = `${API_URL}/private/paid-installments`;
export const CUSTOMERS_URL = `${API_URL}/private/customers`;
export const PAGE_SIZE = 10;

export const CITIES_URL = `${API_URL}/private/cities`;

export const YEARS_OF_BUILT_URL = `${API_URL}/private/years-of-built`;
export const TYPE_OF_HOUSINGS_URL = `${API_URL}/private/type-of-housings`;
export const COMPANY_NAMES_URL = `${API_URL}/private/company-names`;
export const DOWN_PAYMENT_PORTFOLIO_STATUSES_URL = `${API_URL}/private/down-payment-portfolio-statuses`;
export const BARRIER_WITH_TRADITIONAL_SYSTEM_URL = `${API_URL}/private/barrier-with-traditional-system`;
export const FINANCIAL_MODELS_URL = `${API_URL}/private/financial-models`;

export const OPERATION_STATUS = {
  new: "NEW",
  active: "ACTIVE",
  end: "COMPLETED",
  cancel: "CANCEL",
};
export const USER_TYPES = {
  admin: "admin",
  customer: "customer",
};

export const PERMISSIONS_OPTIONS = {
  operations: {
    actions: {
      create: "operations.create",
      activate: "operations.activate",
      edit: "operations.edit",
      cancel: "operations.cancel",
      reopen: "operations.reopen",
    },
  },
  paidInstallments: {
    actions: {
      create: "paidInstallments.create",
    },
  },
};
